import React from 'react'
import Row from '@amzn/meridian/row'
import Column from '@amzn/meridian/column'
import Text from '@amzn/meridian/text'
import Icon from '@amzn/meridian/icon'
import Divider from '@amzn/meridian/divider'
import chevronRightSmallTokens from '@amzn/meridian-tokens/base/icon/chevron-right-small'

interface ISettingsMenuItemProps {
    label: string
    onClick: () => void
    disabled?: boolean
    testId?: string
}

/**
 * A menu item row with left-aligned label and right-aligned chevron.
 * Uses role="button" with keyboard handling for accessibility.
 * Matches Figma design: plain text, full-width tap target, divider below.
 */
export const SettingsMenuItem: React.FC<ISettingsMenuItemProps> = ({
    label,
    onClick,
    disabled = false,
    testId,
}) => {
    return (
        <Column spacing="none">
            <div
                role="button"
                tabIndex={disabled ? -1 : 0}
                onClick={disabled ? undefined : onClick}
                onKeyDown={(e) => {
                    if (disabled) return
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault()
                        onClick()
                    }
                }}
                data-testid={testId}
                aria-disabled={disabled}
                style={{
                    padding: '16px 0',
                    cursor: disabled ? 'not-allowed' : 'pointer',
                    opacity: disabled ? 0.5 : 1,
                }}
            >
                <Row alignmentVertical="center" widths={['fill', 'fit']}>
                    <Text type="b300" color={disabled ? 'secondary' : 'primary'}>
                        {label}
                    </Text>
                    <Icon tokens={chevronRightSmallTokens} />
                </Row>
            </div>
            <Divider />
        </Column>
    )
}
